import styled from '@emotion/styled'
import { ButtonHTMLAttributes, ReactElement } from 'react'
import {
  BorderProps,
  ColorProps,
  DisplayProps,
  FlexboxProps,
  LayoutProps,
  PositionProps,
  ShadowProps,
  SpaceProps,
  TypographyProps,
  border,
  color,
  display,
  flexbox,
  layout,
  position,
  shadow,
  space,
  system,
  typography,
} from 'styled-system'

import { TestIdProps, WhiteSpaceProps } from 'designSystem/types/propTypes'

type Props = ButtonHTMLAttributes<HTMLButtonElement> &
  BorderProps &
  ColorProps &
  DisplayProps &
  FlexboxProps &
  LayoutProps &
  PositionProps &
  ShadowProps &
  SpaceProps &
  TestIdProps &
  TypographyProps &
  WhiteSpaceProps

export default function INTERNALxButton({
  testId,
  ...props
}: Props): ReactElement {
  return <INTERNALxButtonElement data-testid={testId} {...props} />
}

const INTERNALxButtonElement = styled.button<Props>`
  ${border}
  ${color}
  ${display}
  ${flexbox}
  ${layout}
  ${position}
  ${shadow}
  ${space}
  ${typography}
  ${system({
    whiteSpace: {
      property: 'whiteSpace',
    },
  })}
`
